import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
export const ActivityCalendarPaginateButton = ({ isNext, onClick }) => {
    return (React.createElement("button", { onClick: onClick, className: css(styles.btn, isNext ? styles.next : styles.prev) }, isNext ? (React.createElement("img", { src: "/assets/images/icons/right_plane_arrow.svg", className: css(styles.icon) })) : (React.createElement("img", { src: "/assets/images/icons/left_plane_arrow.svg", className: css(styles.icon) }))));
};
const styles = StyleSheet.create({
    btn: {
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        position: 'absolute',
        top: '46%',
        padding: 0,
        width: 'calc((100vw - 100% - 65px) / 2)',
        height: 30,
        backgroundColor: '#444444',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        [MediaBreakPointUp.MD]: {
            width: 25,
        },
        [MediaBreakPointUp.XL]: {
            width: 32,
            height: 32,
        },
    },
    icon: {
        color: Colors.White,
        height: 14,
    },
    prev: {
        left: 0,
        transform: 'translateX(-100%)',
    },
    next: {
        right: 0,
        transform: 'translateX(100%)',
    },
});
